module.exports = __webpack_public_path__ + "img/fish.80309a3b.svg";